/* eslint-disable react/no-array-index-key */
import { TypographyH4 } from "@/components/typography/H4";
import { TypographyMuted } from "@/components/typography/Muted";
import { useAnimate } from "framer-motion";
import { Medal } from "lucide-react";
import { useEffect } from "react";

export function OnboardingCompleted() {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    async function enterAnimation() {
      await animate(
        "#icon",
        { transform: "scale(1.4)" },
        { duration: 0.8, type: "tween", ease: "backOut" }
      );
      animate(
        "#icon",
        { transform: "scale(1)" },
        { duration: 0.3, type: "tween", ease: "circIn" }
      );
      await animate(
        "#iconBox",
        { height: "100%", width: "100%" },
        { delay: 0.15, duration: 0.6, type: "tween", ease: "anticipate" }
      );
      await animate(
        ".line",
        {
          opacity: 1,
          transform: "translateX(70px)",
          width: 0
        },
        {
          duration: 0.6,
          type: "tween",
          opacity: { duration: 0 },
          width: { duration: 0.3, delay: 0.3 }
        }
      );
      await animate(
        "#onboardingCard",
        { opacity: 1, bottom: 0 },
        { delay: 0.4, duration: 0.5 }
      );
    }

    enterAnimation();
  }, [animate]);

  return (
    <div className="border-b dark:border-brand-gray-800 pb-12 mb-6">
      <div ref={scope} className="relative w-full pt-16">
        <div className="absolute z-10 top-0 left-1/2 -translate-x-1/2 w-24 h-24 border-4 border-white dark:border-brand-gray-950 rounded-full flex items-center justify-center">
          {Array.from({ length: 16 }).map((_, i) => {
            return (
              <div
                key={i}
                className="line absolute top-1/2 left-1/2 origin-left bg-brand-primary opacity-0"
                style={{
                  width: "25px",
                  height: "1px",
                  rotate: `${(360 / 16) * i}deg`,
                  transform: `translateY(-50%) translateX(20px)`
                }}
              />
            );
          })}
          <div
            id="iconBox"
            className="absolute top-0 left-0 right-0 bottom-0 m-auto bg-brand-primary h-0 w-0 rounded-full"
          />
          <Medal id="icon" className="scale-100" size={35} />
        </div>
        <div
          id="onboardingCard"
          className="p-12 w-full border border-brand-primary dark:bg-brand-gray-900 rounded-md flex flex-col gap-5 items-center justify-center relative bottom-4 opacity-0"
        >
          <TypographyH4>You completed all the steps. Good job!</TypographyH4>
          <TypographyMuted>
            Now, you are ready to take full advantage of Numerous. To keep
            learning, be sure to check out our docs.
          </TypographyMuted>
        </div>
      </div>
    </div>
  );
}
